export enum Status {
  Going = 'GOING',
  Interested = 'INTERESTED',
  NotGoing = 'NOT_GOING',
  Requested = 'REQUESTED',
  Denied = 'DENIED',
}
